import { CANONICAL_PUBLIC_ORIGIN, canBootPublicApp } from "./lib/public-app-url";
import "./index.css";

function renderRetiredHostNotice(root: HTMLElement): void {
  document.title = "BEAM";
  root.innerHTML = `<main role="main" style="min-height:100vh;display:grid;place-content:center;gap:1rem;padding:2rem;text-align:center"><h1>This address is no longer available</h1><p>BEAM is available at its official address.</p><a href="${CANONICAL_PUBLIC_ORIGIN}">Open beamstream.org</a></main>`;
}

function renderBootLoading(root: HTMLElement): void {
  root.innerHTML =
    '<main role="status" aria-live="polite" style="min-height:100vh;display:grid;place-content:center;padding:2rem;text-align:center"><h1>Loading BEAM</h1></main>';
}

function renderBootFailure(root: HTMLElement): void {
  root.innerHTML =
    '<main role="alert" style="min-height:100vh;display:grid;place-content:center;gap:1rem;padding:2rem;text-align:center"><h1>BEAM could not load</h1><p>Check your connection, then try again.</p><button type="button">Try again</button></main>';
  root.querySelector("button")?.addEventListener("click", () => window.location.reload());
}

const root = document.getElementById("root")!;
const isProductionE2eLoopback =
  import.meta.env.VITE_E2E_PRODUCTION === "1" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

if (!isProductionE2eLoopback && !canBootPublicApp(window.location.hostname)) {
  renderRetiredHostNotice(root);
} else {
  renderBootLoading(root);
  void import("./app-bootstrap")
    .then(({ bootApp }) => bootApp(root))
    .catch(() => renderBootFailure(root));
}
